const Calculator = () => (
  <svg
    width="30px"
    height="35px"
    viewBox="0 0 30 35"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="DB_TransformerLP_Calculator_v2"
        transform="translate(-901.000000, -1054.000000)"
        fill="#697B84"
        fillRule="nonzero"
      >
        <g id="calculate" transform="translate(728.000000, 1029.000000)">
          <g id="calculator-(1)" transform="translate(173.000000, 25.000000)">
            <path
              d="M27,0 L3,0 C1.3458,0 0,1.3458 0,3 L0,31.1333333 C0,32.7875333 1.3458,34.1333333 3,34.1333333 L27,34.1333333 C28.6542,34.1333333 30,32.7875333 30,31.1333333 L30,3 C30,1.3458 28.6542,0 27,0 Z M28,31.1333333 C28,31.6847333 27.5514,32.1333333 27,32.1333333 L3,32.1333333 C2.4486,32.1333333 2,31.6847333 2,31.1333333 L2,3 C2,2.4486 2.4486,2 3,2 L27,2 C27.5514,2 28,2.4486 28,3 L28,31.1333333 Z"
              id="Shape"
            />
            <path
              d="M25,4 L5,4 C4.44773333,4 4,4.44773333 4,5 L4,13.1333333 C4,13.6856 4.44773333,14.1333333 5,14.1333333 L25,14.1333333 C25.5522667,14.1333333 26,13.6856 26,13.1333333 L26,5 C26,4.44773333 25.5522667,4 25,4 Z M24,12.1333333 L6,12.1333333 L6,6 L24,6 L24,12.1333333 Z"
              id="Shape"
            />
            <path
              d="M9,16.1333333 L5,16.1333333 C4.44773333,16.1333333 4,16.5810667 4,17.1333333 L4,21.1333333 C4,21.6856 4.44773333,22.1333333 5,22.1333333 L9,22.1333333 C9.55226667,22.1333333 10,21.6856 10,21.1333333 L10,17.1333333 C10,16.5810667 9.55226667,16.1333333 9,16.1333333 Z M8,20.1333333 L6,20.1333333 L6,18.1333333 L8,18.1333333 L8,20.1333333 Z"
              id="Shape"
            />
            <path
              d="M9,24.1333333 L5,24.1333333 C4.44773333,24.1333333 4,24.5810667 4,25.1333333 L4,29.1333333 C4,29.6856 4.44773333,30.1333333 5,30.1333333 L9,30.1333333 C9.55226667,30.1333333 10,29.6856 10,29.1333333 L10,25.1333333 C10,24.5810667 9.55226667,24.1333333 9,24.1333333 Z M8,28.1333333 L6,28.1333333 L6,26.1333333 L8,26.1333333 L8,28.1333333 Z"
              id="Shape"
            />
            <path
              d="M17,16.1333333 L13,16.1333333 C12.4477333,16.1333333 12,16.5810667 12,17.1333333 L12,21.1333333 C12,21.6856 12.4477333,22.1333333 13,22.1333333 L17,22.1333333 C17.5522667,22.1333333 18,21.6856 18,21.1333333 L18,17.1333333 C18,16.5810667 17.5522667,16.1333333 17,16.1333333 Z M16,20.1333333 L14,20.1333333 L14,18.1333333 L16,18.1333333 L16,20.1333333 Z"
              id="Shape"
            />
            <path
              d="M17,24.1333333 L13,24.1333333 C12.4477333,24.1333333 12,24.5810667 12,25.1333333 L12,29.1333333 C12,29.6856 12.4477333,30.1333333 13,30.1333333 L17,30.1333333 C17.5522667,30.1333333 18,29.6856 18,29.1333333 L18,25.1333333 C18,24.5810667 17.5522667,24.1333333 17,24.1333333 Z M16,28.1333333 L14,28.1333333 L14,26.1333333 L16,26.1333333 L16,28.1333333 Z"
              id="Shape"
            />
            <path
              d="M25,16.1333333 L21,16.1333333 C20.4477333,16.1333333 20,16.5810667 20,17.1333333 L20,29.1333333 C20,29.6856 20.4477333,30.1333333 21,30.1333333 L25,30.1333333 C25.5522667,30.1333333 26,29.6856 26,29.1333333 L26,17.1333333 C26,16.5810667 25.5522667,16.1333333 25,16.1333333 Z M24,28.1333333 L22,28.1333333 L22,18.1333333 L24,18.1333333 L24,28.1333333 Z"
              id="Shape"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Calculator;
